import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StudioExperienceBannerImg from '@src/assets/images/studio-experience-banner.svg';
import { StyledBannerCreateSampleProject } from './index.style';

const BannerCreateSampleProject = ({
  handleCreateSampleProject,
  loadingCreateProject,
}) => {
  const { t } = useTranslation();

  return (
    <StyledBannerCreateSampleProject>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <img src={StudioExperienceBannerImg} alt="studio-experience-banner" />
        <div className="banner-content">
          <div className="banner-content-title">
            <Typography>{t('tryProjects')}</Typography>
          </div>
          <div className="banner-content-description">
            <Typography>{t('sampleProjectDescription')}</Typography>
          </div>
        </div>
      </div>
      <div className="content-button-container">
        <button
          onClick={handleCreateSampleProject}
          className="button-gradient"
          type="button"
        >
          {loadingCreateProject ? (
            <CircularProgress
              value={75}
              className="circular-progress"
              size="24px"
            />
          ) : (
            t('createSampleProject')
          )}
        </button>
      </div>
    </StyledBannerCreateSampleProject>
  );
};

export default BannerCreateSampleProject;
